import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import useNotifications from '../hooks/useNotifications';
import useTemplates from '../hooks/useTemplates';
import { useAuth } from '../context/AuthContext';

function PageHeader() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const { userName, userEmail, logout } = useAuth();

  const {
    notifications,
    showNotifications,
    setShowNotifications,
    markNotificationAsRead,
    clearAllNotifications
  } = useNotifications();

  const { templates } = useTemplates();

  const searchResults = useMemo(() => {
    if (!searchQuery.trim()) return null;

    const query = searchQuery.toLowerCase();
    const filteredTemplates = templates.filter((template) =>
      template.name?.toLowerCase().includes(query)
      || template.prompt?.toLowerCase().includes(query)
      || template.category?.toLowerCase().includes(query)
    );

    return {
      total: filteredTemplates.length,
      templates: filteredTemplates,
      posts: []
    };
  }, [searchQuery, templates]);

  const handleNavigate = (target) => {
    const map = {
      settings: '/settings',
      plans: '/plans',
      help: '/help'
    };

    navigate(map[target] || '/home');
  };

  return (
    <TopBar
      searchQuery={searchQuery}
      onSearch={setSearchQuery}
      searchResults={searchResults}
      onResultClick={() => navigate('/home')}
      notifications={notifications}
      showNotifications={showNotifications}
      setShowNotifications={setShowNotifications}
      onMarkNotificationRead={markNotificationAsRead}
      onClearAllNotifications={clearAllNotifications}
      userName={userName}
      userEmail={userEmail}
      onNavigate={handleNavigate}
      onLogout={() => {
        logout();
        navigate('/');
      }}
    />
  );
}

export default PageHeader;
